import axios from 'axios';
import * as endpoints from '../constants/endpoints';

export function getPortfolio() {
  return axios.get(endpoints.PORTFOLIO);
}


// WEBPACK FOOTER //
// ./src/models/project.js